/* globals PLUG */
(function (Frame) {

	"use strict";

	let U;
	let nav;

	Frame.init = function () {
		U = PLUG.import("Utils");
        nav = document.getElementById("plug-header-nav");
		DesktopNav();
		initDrawers();
		Frame.export = function () {
			return Object.freeze({});
		};
	};

	function DesktopNav() {
        const primaryLinkElements = document.getElementsByClassName("plug-header-brand-tab-link");
        const primaryLinks = U.mapArray(primaryLinkElements, primaryLinkConstructor);

		function primaryLinkConstructor(link, index) {
			const li = link.parentElement;
			const brandHandle = li.dataset.brand;
			const l2List = document.querySelector(".plug-header-l2-links[data-brand='" + brandHandle + "']");
            let isSelected;



			function open() {
                isSelected = true;
				if (link.classList.contains("is-selected")) {
					return;
				}

				closeAll();

				if (l2List) {
					l2List.classList.remove("is-hidden");
					U.afterNextRepaint(function () {
						l2List.classList.remove("is-translucent");
                        nav.classList.add("brand-is-selected");
                        link.classList.add("is-selected");
						// setTimeout(() => {
						// }, 0);
					});
				} else {
					link.classList.add("is-selected");
				}
			}

			function close() {
                console.log("close " + index);
                isSelected = false;
                if (link.classList.contains("is-selected")) {
                    link.classList.remove("is-selected");
                    nav.classList.remove("brand-is-selected");
                }

                //     primaryLinks.forEach((primaryLink, index) => {
                //         if (primaryLink.isOpen()) {
                //             console.log(index + " is open.");
                //         }
                //     });
                // }
				if (l2List) {
					l2List.classList.add("is-translucent");
					l2List.classList.add("is-hidden");
				}
			}

            function isOpen() {
                return isSelected;
            }

			let openTimer;
			let closeTimer;
			link.addEventListener("mouseenter", function () {
				clearTimeout(openTimer);
				clearTimeout(closeTimer);
                openTimer = setTimeout(open, 300);
			}, false);

			link.addEventListener("mouseleave", function () {
				clearTimeout(closeTimer);
				clearTimeout(openTimer);
				closeTimer = setTimeout(close, 300);
			});

            link.querySelector(".left-shadow").addEventListener("mouseenter", () => {
                if (index === 0) {
                    closeTimer = setTimeout(close, 300);
                } else {
                    openTimer = setTimeout(primaryLinks[index - 1].open, 300);
                }
            });

            link.querySelector(".right-shadow").addEventListener("mouseenter", () => {
                if (index === primaryLinks.length - 1) {
                    closeTimer = setTimeout(close, 300);
                } else {
                    openTimer = setTimeout(primaryLinks[index + 1].open, 300);
                }
            });

			if (l2List) {
				l2List.addEventListener("mouseenter", function () {
                    console.log("l2List mouseenter " + index);
					clearTimeout(closeTimer);
                    // openTimer = setTimeout(open, 500);
				});

				l2List.addEventListener("mouseleave", function () {
                    console.log("l2List mouseleave " + index);
					clearTimeout(closeTimer);
					closeTimer = setTimeout(close, 300);
				});

				const l2Items = l2List.getElementsByClassName("plug-header-l2-item");
				U.mapArray(l2Items, secondaryLinkConstructor);
			}

			function secondaryLinkConstructor(l2Item) {
				const l2Link = l2Item.getElementsByClassName("plug-header-l2-link")[0];
				const l3List = l2Item.getElementsByClassName("plug-header-l3-links")[0];

				let openDropdownTimer;
				let closeDropdownTimer;

				function openL3List() {
					l2Link.classList.add("is-selected");
					if (!l3List || !l3List.classList.contains("is-hidden")) {
						return;
					}
					l3List.classList.remove("is-hidden");
					U.afterNextRepaint(function () {
						l3List.classList.remove("is-translucent");
					});
				}

				function closeL3List() {
					l2Link.classList.remove("is-selected");
					if (l3List) {
						l3List.classList.add("is-hidden");
						l3List.classList.add("is-translucent");
					}
				}

				l2Link.addEventListener("mouseenter", function () {
					clearTimeout(closeTimer);
					clearTimeout(openDropdownTimer);
					clearTimeout(closeDropdownTimer);
					openDropdownTimer = setTimeout(openL3List, 100);
				});

				l2Link.addEventListener("mouseleave", function () {
					clearTimeout(openDropdownTimer);
					clearTimeout(closeDropdownTimer);
					closeDropdownTimer = setTimeout(closeL3List, 100);
					// closeTimer = setTimeout(close, 100);
				});

				if (l3List) {
					l3List.addEventListener("mouseenter", function () {
                        console.log("l3List mouseenter");
						clearTimeout(closeTimer);
						clearTimeout(closeDropdownTimer);
					});
					l3List.addEventListener("mouseleave", function () {
                        console.log("l3List mouseleave");
						closeDropdownTimer = setTimeout(closeL3List, 100);
						closeTimer = setTimeout(close, 100);
					});
				}
				return Object.freeze({
					open: openL3List,
					close: closeL3List
				});
			}

			return Object.freeze({
				close,
				open,
                isOpen
			});
		}

		function closeAll() {
			primaryLinks.forEach(function (link) {
				link.close();
			});
		}
	}

	function initDrawers() {

		class PlugMenuDrawer extends HTMLElement {
			constructor() {
				super();
				this.menu = this.querySelector(".plug-header-drawer-menu");
				this.menuButton = this.querySelector(".js-open-menu-drawer");
				this.bindEvents();
			}

			bindEvents() {
				this.addEventListener("keyup", (event) => {
					if (event.code.toUpperCase() === "ESCAPE" && this.isOpen) {
						this.closeMenuDrawer();
					}
				});
				if (this.menuButton) {
					this.menuButton.addEventListener("click", () => (
						this.isOpen
						? this.closeMenuDrawer()
						: this.openMenuDrawer()
					));
				}
			}

			openMenuDrawer() {
				if (this.isOpen) {
					return;
				}
				this.isOpen = true;
				this.menuButton.dataset.open = "true";
				const menu = this.menu;
				menu.classList.add("is-visible");
				U.afterNextRepaint(() => {
					menu.classList.add("is-open");
				});
			}

			closeMenuDrawer() {
				if (!this.isOpen) {
					return;
				}
				this.isOpen = false;
				this.menuButton.dataset.open = "false";
				const menu = this.menu;
				menu.classList.remove("is-open");
				setTimeout(function () {
					menu.classList.remove("is-visible");
				}, 300);
			}
		}

		customElements.define("plug-menu-drawer", PlugMenuDrawer);

		class PlugHeaderDrawer extends PlugMenuDrawer {
			constructor() {
				super();
				this.bindHeaderMenuEvents();
			}

			bindHeaderMenuEvents() {
				const brandLinks = this.querySelectorAll(".plug-header-drawer-brands .plug-header-drawer-menu-item-link");
				brandLinks.forEach((link) => {
					link.addEventListener("click", this.openL2Menu.bind(this));
				});
				const l2Links = this.querySelectorAll(".plug-header-drawer-l2-menu a.plug-header-drawer-menu-item-link");
				l2Links.forEach(link => {
					link.addEventListener("click", this.openL3Menu.bind(this));
				});
				const goBackItems = this.querySelectorAll(".js-go-back");
				goBackItems.forEach(item => {
					item.querySelector(".plug-header-drawer-menu-item-link").addEventListener(
						"click",
						() => {
							const list = item.parentElement;
							list.classList.remove("is-open");
							setTimeout(() => {
								list.classList.remove("is-visible");
							}, 300);
						}
					);
				});
			}

			openL2Menu(event) {
				event.preventDefault();
				const link = event.target;
				const li = link.parentElement;
				const brandHandle = li.dataset.brand;
				const l2Menu = this.querySelector(".plug-header-drawer-l2-menu[data-brand='" + brandHandle + "']");
				l2Menu.classList.add("is-visible");
				U.afterNextRepaint(() => {
					l2Menu.classList.add("is-open");
				});
			}

			openL3Menu(event) {
				event.preventDefault();
				const link = event.target;
				const li = link.parentElement;
				const l2Name = li.dataset.handle;
				const l3Menu = this.querySelector(".plug-header-drawer-l3-menu[data-l2='" + l2Name + "']");
				l3Menu.classList.add("is-visible");
				U.afterNextRepaint(() => {
					l3Menu.classList.add("is-open");
				});
			}
		}

		customElements.define("plug-header-drawer", PlugHeaderDrawer);
	}

})(PLUG.Frame = Object.create(null));
